import React from 'react';
import { ReactComponent as CloseModalIcon } from '../assets/svg/CloseModalIcon.svg';
import { useUser } from '../auth/UseUser';
import ItemLink from './common/ItemLink';
import { getEntityPath } from '../utils/entityPath';

function SideBarUser({
    toggleSideBar,
    backbutton = false,
    sideBarList = [],
    handleSelect,
    isOpen,
}: {
    toggleSideBar?: any;
    backbutton?: boolean;
    sideBarList?: any;
    handleSelect?: any;
    isOpen: any;
}) {
    const { selectedPitanje, setSelectedPitanje } = useUser();
    return (
        <div
            className={`h-full ${isOpen ? 'min-w-[260px] w-[260px]' : 'w-0'} fixed top-[106px] bottom-0 left-0 lg:static lg:bottom-auto lg:min-w-[260px] lg:w-[260px] transition-all duration-300 z-[2]`}
        >
            <div className={`w-full h-full overflow-y-auto gray-small-scroll bg-blueDark  ${isOpen ? 'border-r border-r-gold' : 'lg:border-r lg:border-r-gold'}`}>
                <div className="h-10 flex flex-row items-center  mt-5 px-5">
                    <div
                        className={`${backbutton ? '' : 'invisible'} lg:invisible`}
                        onClick={() => {
                            toggleSideBar();
                        }}
                    >
                        <CloseModalIcon />
                    </div>
                </div>
                <div>
                    {sideBarList
                        .sort((a: any, b: any) => a.redosled - b.redosled)
                        .map((item: any, index: number) => {
                            return (
                                <ItemLink
                                    className={`w-full flex flex-row  py-[10px] pl-5 pr-3 cursor-pointer transition ${selectedPitanje?.id === item?.id ? 'bg-blueLight' : 'hover:bg-blueMedium '}`}
                                    key={index}
                                    href={getEntityPath(item)}
                                    onActivate={() => handleSelect(item)}
                                >
                                    <div className="min-w-[12px] w-3 h-3 rounded-full bg-gold mr-2 mt-1"></div>
                                    <p className="text-white text-[16px] leading-5">{item.naziv}</p>
                                </ItemLink>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

export default SideBarUser;
